import { ButtonLink } from '../components/ui/Button';

interface PlaceholderProps {
  title: string;
  description?: string;
}

export default function Placeholder({ title, description }: PlaceholderProps) {
  return (
    <section className="section-shell">
      <div className="mx-auto max-w-xl py-16 text-center">
        <span className="eyebrow">Coming next</span>
        <h1 className="mt-4 text-4xl">{title}</h1>
        <p className="mt-4 text-base leading-relaxed text-brand-900/60">
          {description ??
            'This page is scaffolded and ready. We will build it out in the next step.'}
        </p>
        <ButtonLink to="/" variant="primary" size="lg" className="mt-8">
          Back to home
        </ButtonLink>
      </div>
    </section>
  );
}
